import { getAllClientsAdapter, getClientsAdapter } from '@api/FW/adapters/getClients.adapter';
import { getQueryParams, httpApi } from '@api/FW/http.api';
import { Client, ClientAdapter } from '@interfaces/FW/Client';

export const getClients = (): Promise<Client> => {
	return httpApi
		.get<ClientAdapter[]>('Clients', { params: getQueryParams() })
		.then(({ data }) => {
			return getClientsAdapter(data);
		})
		.catch((err) => {
			throw err;
		});
};

export const getAllClients = (): Promise<Client[]> => {
	return httpApi
		.get<ClientAdapter[]>('Clients', { params: getQueryParams() })
		.then(({ data }) => {
			return getAllClientsAdapter(data);
		})
		.catch((err) => {
			throw err;
		});
};
